declare interface PageNotFoundProps {
  isNotAdminPage?: boolean;
}
export function PageNotFound({isNotAdminPage} : PageNotFoundProps): JSX.Element {
  return (
    <div className={`${isNotAdminPage && 'mt-5'} w-full flex items-center justify-center dark:bg-slay-800 text-gray-800 dark:text-white`}>
      <h1 className="text-4xl font-bold">404. Page not found. Please check your link.</h1>
    </div>
  )
}
